import styled from 'react-emotion'
import * as React from 'react'
import { Row, Column, styleguide } from 'styleguide'

const FakeBrowser = styled(Column)`
  background-color: black;
  width: 100%;
  max-width: 1000px;
  border-radius: ${styleguide.radii.browser};
  overflow: hidden;
  position: relative;
  z-index: 30;
  transition: all 300ms ease;
  transform: translate3d(0, ${props => (props.shown ? '0px' : '40px')}, 0);
  ${styleguide.shadows.button};
`

const Backdrop = styled(Row)`
  background-color: rgba(255, 255, 255, 0.9);
  opacity: ${props => (props.shown ? 1 : 0)};
  pointer-events: ${props => (props.shown ? 'auto' : 'none')};
  position: fixed;
  transition: all 300ms ease;
  padding: ${styleguide.spacing.large};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
`

export default ({ offClick, shown, children }) => (
  <Backdrop onClick={offClick} shown={shown}>
    <FakeBrowser justify="start" align="stretch" shown={shown} grow>
      <iframe
        title="product-hunt"
        style={{
          width: '100%',
          height: '80vh',
          zIndex: 1,
          position: 'relative',
        }}
        src="https://www.producthunt.com/upcoming/scoops-2"
        frameBorder="0"
      />
    </FakeBrowser>
  </Backdrop>
)



// WEBPACK FOOTER //
// ./src/components/Ship.jsx